import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

export const AUTONOMOUS = 'autonomous'; // autonome
export const CRANE = 'crane'; // grue
export const FORKLIFT = 'forklift'; // chariot élévateur
export const ORGANIZER = 'organizer'; // organisateur
export const PALLET_TRUCK = 'pallet_truck'; // transpalette

export default [AUTONOMOUS, CRANE, FORKLIFT, ORGANIZER, PALLET_TRUCK];

export const getTranslatedlMeanLabel = (reference: string) => {
  switch (reference) {
    case AUTONOMOUS:
      return <FormattedMessageWrapper id="autonome" />;
    case CRANE:
      return <FormattedMessageWrapper id="grue" />;
    case FORKLIFT:
      return <FormattedMessageWrapper id="chariot élévateur" />;
    case ORGANIZER:
      return <FormattedMessageWrapper id="organisateur" />;
    case PALLET_TRUCK:
      return <FormattedMessageWrapper id="transpalette" />;
    default:
      return '';
  }
};
